<template>

  <div style="width:auto; height: auto;">
    <!-- <div class="winwheelicon" style="background-repeat: no-repeat;"></div> -->
    <canvas className="ta_c" id="canvas" width="500px" height="450px"></canvas>
  </div>
</template>

<script>
/* eslint-disable */
import Winwheel from "winwheel";
import swal from "sweetalert";

export default {
  data: function () {
    return {
      resultWin: "",
      winwheel: null,
      list: [],
      arc: null,
      ctx: null,
      spinArcStart: 10,
      spinTime: 0,
      spinTimeTotal: 0,
      startAngle: 0,
      options: [],    // 상품 이름
      winProb: [],    // 당첨 확률
      prodCnt: [],    // 상품 갯수
      winnerCnt: [],  // 당첨자 수
    };
  },
  props: ["option"],
  created: function () {
  },
  mounted: function () {
    let vm = this;

    if (vm.option != null && vm.option.length > 0) {
      let _list = [];
      let _list2 = [];
      let _list3 = [];
      let _list4 = [];

      vm.option.forEach(function (item, idx) {
        _list.push(item.title);
        _list2.push(parseInt(item.content));
        _list3.push(parseInt(item.count));
        _list4.push(parseInt(item.winnerCnt));
      });

      vm.options = _list;
      vm.winProb = _list2;
      vm.prodCnt = _list3;
      vm.winnerCnt = _list4;
    }

    vm.getWinwheel();
  },
  watch: {
    option: function (newVal, oldVal) {
      let vm = this;
      if (newVal.length > 0) {
        let _list = [];
        let _list2 = [];
        let _list3 = [];
        let _list4 = [];

        newVal.forEach(function (item, idx) {
          _list.push(item.title);
          _list2.push(parseInt(item.content));
          _list3.push(parseInt(item.count));
          _list4.push(parseInt(item.winnerCnt));
        });

        vm.options = _list;
        vm.winProb = _list2;
        vm.prodCnt = _list3;
        vm.winnerCnt = _list4;
      }

      vm.getWinwheel();
    }
  },
  methods: {
    getWinwheel: function () {
      let vm = this;
      vm.arc = Math.PI / (vm.options.length / 2);

      function byte2Hex(n) {
        var nybHexString = "0123456789ABCDEF";
        return (
          String(nybHexString.substr((n >> 4) & 0x0f, 1)) +
          nybHexString.substr(n & 0x0f, 1)
        );
      }

      function RGB2Color(r, g, b) {
        return "#" + byte2Hex(r) + byte2Hex(g) + byte2Hex(b);
      }

      function getOutsideColor(item, maxitem) {
        // var phase = 0;
        // var center = 128;
        // var width = 127;
        // var frequency = (Math.PI * 2) / maxitem;

        // let red = Math.sin(frequency * item + 2 + phase) * width + center;
        // let green = Math.sin(frequency * item + 0 + phase) * width + center;
        // let blue = Math.sin(frequency * item + 4 + phase) * width + center;

        if (item % 2 == 0) {
          var red = 251;
          var green = 163;
          var blue = 125;
        }
        if (item % 2 == 1) {
          var red = 255;
          var green = 255;
          var blue = 255;
        }

        return RGB2Color(red, green, blue);
      }

      function getInsideColor(item, maxitem) {
        if (item % 2 == 0) {
          var red = 245;
          var green = 245;
          var blue = 245;
        }
        if (item % 2 == 1) {
          var red = 246;
          var green = 114;
          var blue = 46;
        }
        return RGB2Color(red, green, blue);
      }


      function getColor(item, maxitem) {
        if (maxitem != 4) {
          if (item % 3 == 1) {
            var red = 222;
            var green = 222;
            var blue = 222;
          }
          if (item % 3 == 2) {
            var red = 240;
            var green = 240;
            var blue = 240;
          }
          if (item % 3 == 0) {
            var red = 255;
            var green = 255;
            var blue = 255;
          }
        } else {
          if (item % 2 == 1) {
            var red = 222;
            var green = 222;
            var blue = 222;
          }
          if (item % 2 == 0) {
            var red = 255;
            var green = 255;
            var blue = 255;
          }
        }
        return RGB2Color(red, green, blue);
      }

      let imgPath = new Image();
      imgPath.src = "/design/common/images/roulette/niddle.png"

      var canvas = document.getElementById("canvas");
      if (canvas.getContext) {
        var outsideRadius = 135;
        var textRadius = 90;
        var insideRadius = 0;

        vm.ctx = canvas.getContext("2d");
        vm.ctx.clearRect(0, 0, 500, 500);

        vm.ctx.strokeStyle = "#c2c2c2";
        vm.ctx.lineWidth = 1;

        vm.ctx.font = "bold 20px Helvetica, consolas";

        vm.arc = Math.PI / (vm.options.length * 4 / 2);

        for (var i = 0; i < vm.options.length * 4; i++) {
          var angle = vm.startAngle + i * vm.arc;
          vm.ctx.beginPath();
          vm.ctx.arc(250, 250, outsideRadius + 15, angle, angle + vm.arc, false);
          vm.ctx.arc(250, 250, outsideRadius + 10, angle + vm.arc, angle, false);
          vm.ctx.fillStyle = getOutsideColor(i + 1, vm.options.length);
          vm.ctx.fill();
        }
        for (var i = 0; i < vm.options.length * 4; i++) {
          var angle = vm.startAngle + i * vm.arc;
          vm.ctx.beginPath();
          vm.ctx.arc(250, 250, outsideRadius + 10, angle, angle + vm.arc, false);
          vm.ctx.arc(250, 250, outsideRadius, angle + vm.arc, angle, false);
          vm.ctx.fillStyle = getInsideColor(i, vm.options.length);
          vm.ctx.fill();
        }

        vm.arc = Math.PI / (vm.options.length / 2);

        for (var i = 0; i < vm.options.length; i++) {
          var angle = vm.startAngle + i * vm.arc;
          // var outAngle = vm.startAngle + i * vm.arc;

          // vm.ctx.beginPath();

          // vm.ctx.arc(250, 250, outsideRadius, angle, angle + vm.arc, false);
          // vm.ctx.arc(250, 250, insideRadius, angle + vm.arc, angle, true);
          // vm.ctx.fillStyle = getInsideColor(i, vm.options.length);
          // vm.ctx.fill();
          // // vm.ctx.stroke();

          // vm.ctx.arc(250, 250, outsideRadius+13, angle + vm.arc, outAngle, true);
          // vm.ctx.arc(250, 250, insideRadius, angle + vm.arc, outAngle, true);
          // vm.ctx.fillStyle = getOutsideColor(i + 1, vm.options.length);
          // vm.ctx.fill();

          // vm.ctx.arc(250, 250, outsideRadius+20, angle, angle + vm.arc, false);
          // vm.ctx.arc(250, 250, insideRadius, angle + vm.arc, angle, true);
          // vm.ctx.fillStyle = getInsideColor(i, vm.options.length);
          // vm.ctx.fill();

          // // vm.ctx.stroke();


          vm.ctx.beginPath();
          vm.ctx.arc(250, 250, outsideRadius, angle, angle + vm.arc, false);
          vm.ctx.arc(250, 250, insideRadius, angle + vm.arc, angle, true);

          vm.ctx.fillStyle = getColor(i + 1, vm.options.length);
          vm.ctx.fill();


          vm.ctx.save();
          vm.ctx.shadowOffsetX = -1;
          vm.ctx.shadowOffsetY = -1;
          vm.ctx.shadowBlur = 0;
          // vm.ctx.shadowColor = "rgb(220,220,220)";
          vm.ctx.fillStyle = "black";
          vm.ctx.translate(
            250 + Math.cos(angle + vm.arc / 2) * textRadius,
            250 + Math.sin(angle + vm.arc / 2) * textRadius
          );
          vm.ctx.rotate(angle + vm.arc / 2 + Math.PI / 2);
          var text = vm.options[i];
          vm.ctx.fillText(text, -vm.ctx.measureText(text).width / 2, 0);
          vm.ctx.restore();
        }

        //Arrow
        // vm.ctx.fillStyle = "black";
        // vm.ctx.beginPath();
        // vm.ctx.moveTo(250 - 8, 250 - (outsideRadius + 10));
        // vm.ctx.lineTo(250 + 8, 250 - (outsideRadius + 10));
        // vm.ctx.lineTo(250 + 8, 250 - (outsideRadius - 10));
        // vm.ctx.lineTo(250 + 18, 250 - (outsideRadius - 10));
        // vm.ctx.lineTo(250 + 0, 250 - (outsideRadius - 26));
        // vm.ctx.lineTo(250 - 18, 250 - (outsideRadius - 10));
        // vm.ctx.lineTo(250 - 8, 250 - (outsideRadius - 10));
        // vm.ctx.lineTo(250 - 8, 250 - (outsideRadius + 10));
        // vm.ctx.fill();

        imgPath.onload = function () {
          vm.ctx.drawImage(imgPath, 239.5, 90, 46 / 2, 62 / 2);
        }
      }
    },
    spin: function (winner) {
      let vm = this;
      let degree = 0;
      const degree1 = 10.95 / 360;

      // spinAngleStart : 도는 각도 조절 - 기본 값 세 바퀴 설정
      let spinAngleStart = degree1 * 360 * 3;

      //시작점 조절
      spinAngleStart -= degree1 * (90 + 360 / vm.winProb.length / 2);

      // winner : 당첨 번호
      spinAngleStart -= degree1 * 360 / vm.winProb.length * winner;

      vm.spinTime = 0;
      let spinTimeTotal = Math.random() * 3 + 4 * 1000;
      let spinTimeout = null;

      function easeOut(t, b, c, d) {
        var ts = (t /= d) * t;
        var tc = ts * t;
        return b + c * (tc + -3 * ts + 3 * t);
      }

      function rotateWheel() {
        vm.spinTime += 30;
        if (vm.spinTime >= spinTimeTotal) {
          stopRotateWheel();
          return;
        }
        let spinAngle =
          spinAngleStart -
          easeOut(vm.spinTime, 0, spinAngleStart, spinTimeTotal);
        vm.startAngle += (spinAngle * Math.PI) / 180;
        vm.getWinwheel();
        spinTimeout = setTimeout(function () {
          rotateWheel();
        }, 30);

        //setTimeout('rotateWheel', 30);
      }


      function stopRotateWheel() {
        clearTimeout(spinTimeout);
        var degrees = (vm.startAngle * 180) / Math.PI + 90;
        var arcd = (vm.arc * 180) / Math.PI;
        var index = Math.floor((360 - (degrees % 360)) / arcd);
        vm.ctx.save();
        vm.ctx.font = "bold 30px Helvetica, Arial";
        vm.resultWin = vm.options[index];

        let resultValue = vm.option.find(item => item.title == vm.resultWin);

        // vm.$emit("result",  resultValue);

        // 룰렛 결과 데이터 저장
        // vm.$parent.fnWinwheelParticipation(resultValue);
        vm.ctx.restore();
      }

      rotateWheel();
    },
    alertPrize: function (item) {
      let vm = this;
    }
    // alertPrize: function (_item) {
    //   let vm = this;
    //   console.log(_item);
    //   let _list = _item.winwheel.segments;
    //   let _result = _item.winwheel.getIndicatedSegment();
    //   // vm.winwheel.stopAnimation();
    //   vm.$parent.selectDetailInf.evt11 = _result.code;
    //   vm.$parent.selectDetailInf.evt21 = _result.title;
    //   //_item.winwheel.stopAnimation();

    //   if (_result.code == "MEANVRULNV00100") {
    //     swal(_result.title + "당점되었습니다. 다음에 다시 이용해주세요");
    //     vm.$parent.selectDetailInf.evt31 = "ERROR";
    //     vm.$parent.onClickEvnetParticipate(_result.uidKey);
    //   } else {
    //     swal(_result.title + "당점되었습니다. 다음에 다시 이용해주세요");
    //     vm.$parent.selectDetailInf.evt31 = "SUCCESS";
    //     vm.$parent.onClickEvnetParticipate(_result.uidKey);
    //   }
    // }
  },
};
</script>
